import React from "react";

import useTranslate from "hooks/useTranslate";

const TranslateText = ({ text }) => {
  const { translate } = useTranslate();
  return <>{translate(text)}</>;
};

export default TranslateText;
